import React from 'react';

const HOTEL_IMAGE_PLACEHOLDER_PATH =
  'M2.25 15.75l5.159-5.159a2.25 2.25 0 013.182 0l5.159 5.159m-1.5-1.5l1.409-1.409a2.25 2.25 0 013.182 0l2.909 2.909M3.75 21h16.5A2.25 2.25 0 0022.5 18.75V5.25A2.25 2.25 0 0020.25 3H3.75A2.25 2.25 0 001.5 5.25v13.5A2.25 2.25 0 003.75 21z';

interface HotelImagePlaceholderProps {
  label: string;
  className?: string;
  iconClassName?: string;
  text?: string;
  textClassName?: string;
}

export function HotelImagePlaceholder({
  label,
  className = 'aspect-[16/10] w-full bg-gray-200 flex items-center justify-center',
  iconClassName = 'h-12 w-12 text-gray-400',
  text,
  textClassName = 'mt-2 text-sm text-gray-400',
}: HotelImagePlaceholderProps) {
  return (
    <div aria-label={label} className={className} role='img'>
      <div className='flex flex-col items-center justify-center'>
        <svg
          aria-hidden='true'
          className={iconClassName}
          fill='none'
          stroke='currentColor'
          strokeWidth='1.5'
          viewBox='0 0 24 24'
        >
          <path d={HOTEL_IMAGE_PLACEHOLDER_PATH} strokeLinecap='round' strokeLinejoin='round' />
        </svg>
        {text && <p className={textClassName}>{text}</p>}
      </div>
    </div>
  );
}

/**
 * DOM helper: creates a placeholder <div> element to replace a broken <img>.
 * Keeps slider navigation functional by replacing the img node rather than hiding it.
 */
export function createHotelImagePlaceholderElement(
  label: string,
  options?: { className?: string; iconClassName?: string },
): HTMLDivElement {
  const {
    className = 'flex aspect-[4/3] w-full items-center justify-center bg-gray-200',
    iconClassName = 'h-12 w-12 text-gray-400',
  } = options ?? {};

  const placeholder = document.createElement('div');
  placeholder.className = className;
  placeholder.setAttribute('aria-label', label);
  placeholder.setAttribute('role', 'img');

  const svgStr = `<svg aria-hidden="true" class="${iconClassName}" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24"><path d="${HOTEL_IMAGE_PLACEHOLDER_PATH}" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
  placeholder.innerHTML = svgStr;

  return placeholder;
}
